module.exports = __webpack_public_path__ + "img/logo-small.200b25a7.png";